import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config.service';
//import {GlobalFilterParameterModel } from 'src/app/shared/models/global-filter-parameter.model';

@Injectable({
  providedIn: 'root'
})
export class GlobalFilterService {

  baseApiUrl: string = '';
  apiUrl: string = '';
  getGlobalFilterConfigurationByClientIdUrl = "";
  getGlobalFilterDropDownDataUrl = ""

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseApiUrl = this.configService.getApiURI();
    this.getGlobalFilterConfigurationByClientIdUrl = this.baseApiUrl + '/GlobalFilter/GetGlobalFilterConfigurationByClientId';
    this.getGlobalFilterDropDownDataUrl = this.baseApiUrl + "/GlobalFilter/GetGlobalFilterDropDownData";
  }


  getGlobalFilterConfigurationByClientId(ClientID: number) {
    try {
      return this.http.get(this.getGlobalFilterConfigurationByClientIdUrl + '/' + ClientID);
    }
    catch (Ex) {
      throw Ex;
    }
  }

  getGlobalFilterDropDownData(globalFilterParameterModel: any) {
    try {
      //return this.http.get(this.getGlobalFilterDropDownDataUrl);
      return this.http.post(this.getGlobalFilterDropDownDataUrl, globalFilterParameterModel, { responseType: 'json' });
    }
    catch (Ex) {
      throw Ex;
    }
  }

}
